export function openDrawer(id: string){
    fixScrollGutters();
    window.dispatchEvent(new CustomEvent('show_drawer',{
        detail: {id}
    }));
}
declare global {
    interface HTMLElement {
        showModal: () => void;
        close: () => void;
    }
}
export function closeDrawer(id: string){
    fixScrollGutters()
    window.dispatchEvent(new CustomEvent('close_drawer', {detail: {id}}));
}
export function openModal(id: string){
    fixScrollGutters();
    document.getElementById(id).showModal()
    // window.dispatchEvent(new CustomEvent('open_modal',{
    //     detail: {id}
    // }));
}
export function closeModal(id: string){
    fixScrollGutters()
    document.getElementById(id).close()

//    window.dispatchEvent(new CustomEvent('close_modal', {detail: {id}}));
}


function fixScrollGutters(){
    const body = document.body;
    if (body.scrollHeight > window.innerHeight) {
        body.classList.add("content-overflow-y");
    } else {
        body.classList.remove("content-overflow-y");
    }
}
